// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2588":"7216d4188b00b2a5","5532":"57601e45164cb817","7176":"13c9efe9a503641c","9783":"a38c2285c08442e0"}[chunkId] + ".js";
};